export const FLOW_TRIGGER_UPDATED = 'FLOW_TRIGGER_UPDATED'
export const FLOW_TRIGGER_REMOVED = 'FLOW_TRIGGER_REMOVED'
